import styled from 'styled-components';

const GapBase = styled.div<{
	gap?: 'sm' | 'smd' | 'md' | 'lg';
}>`
	${({ gap = 'md' }) => {
		switch (gap) {
			case 'sm':
				return `gap: 0.3em`;
			case 'smd':
				return `gap: 1em`;
			case 'md':
				return `gap: 1.5em`;
			default:
				return `gap: 3em`;
		}
	}}
`;

export const ButtonsRight = styled(GapBase)`
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

export const ButtonsCenter = styled(GapBase)`
	display: flex;
	justify-content: center;
	gap: 1.5rem;
`;

export const ButtonsApart = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const ButtonsLeft = styled(GapBase)`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;
